'use strict';

import { flow, observable, makeObservable } from "mobx";

import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";

class PlanNavigationStore {
    state = States.initial;

    constructor() {
        makeObservable(this, {
            state: observable
        });

        this.url = 'api/academicHistory/years';
        this.data = null;
        this.exceptionUtils = appStore.getExceptionUtils();
        this.httpClient = appStore.getHttpClient();
    }

    loadData = flow(function* () {
        this.state = States.pending;

        // Don't re-fetch the data if we already have it.
        if (this.hasData()) {
            if (appStore.isDebug()) {
                console.log("PlanNavigationStore.loadData: Using cached data rather than re-fetching.");
            }
            this.state = States.done;
            return;
        }

        try {
            // this calls lib-lambda-myplan AcademicHistoryController.js /academicHistory/years
            this.data = yield this.httpClient.doGet(this.url, 'getAcademicHistory');

            if (appStore.isDevMode()) {
                console.log("PlanNavigationStore: Data load complete.");
            }
            this.state = States.done;
        } catch(error) {
            this.exceptionUtils.handleException(error, "PlanNavigationStore.loadData");
            this.state = States.error;
        }
    });

    /**
     * Check to see if the store has data
     * @return {boolean}
     */
    hasData() {
        return (this.data !== null);
    }

    /**
     * Getter for store data
     * @return {null|array}
     */
    getData() {
        return this.data.elements;
    }
}

export default new PlanNavigationStore();